<script setup>
</script>

<template>
  <!-- footer -->
  <div class="footer">
    <div class="f_inner">
      <div class="f_top">
        <strong class="f_tit">위암 환자 삶의 질 연구회</strong>
        <span class="f_chip">서비스 이용약관</span>
        <span class="f_chip">개인정보처리방침</span>
      </div>
      <p class="f_desc">KOrean QUality of life in Stomach cancer patient Study group (KOQUSS) (대한위암학회 산하 연구회)</p>
      <p class="f_info">
        <span>서울특별시 종로구 새문안로 92 광화문오피시아 1616호</span>
        <span>02-730-3760</span>
      </p>
    </div>
  </div>
  <!-- //footer -->
</template>

<style scoped>
.footer {border-top: 1px solid #DBE0E6;background-color: #fff;margin-top: 1.6rem;}
.f_inner {padding: 1.6rem 2.6rem 1.8rem;}
.f_top {display: flex;align-items: center;gap: 1rem;}
.f_tit {font-size: 2rem;font-weight: 700;color: #212331;}
.f_chip {font-size: 1.3rem;color: #5A6472;border: 1px solid #DBE0E6;border-radius: 2rem;padding: 0.4rem 1.2rem;background-color: #F5F7F9;}
.f_desc {font-size: 1.4rem;color: #5A6472;margin-top: 1.2rem;}
.f_info {display: flex;gap: 2.4rem;font-size: 1.4rem;color: #949AA7;margin-top: 0.8rem;}

/* 모바일 대응 */
@media (max-width: 768px) {
  .f_top {flex-wrap: wrap;}
  .f_info {flex-direction: column;gap: 0.4rem;}
}
</style>
